import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import DecibelMeter from 'decibel-meter';

@Injectable()
export class NavigatorService {


  isRecording = false;
  decibels = 0;
  meter = new DecibelMeter('mic');
  soundLevelArray = [0,0,0,0,0];
  iteration = 0;
  sourceAvailable = false;

  showMsgTimout: any;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  initializeAudioDetection() {
    this.meter.sources.then(sources => {
      if (sources[0].deviceId.length > 0) {
        this.sourceAvailable = true;
        this.meter.connect(sources[0]);
      } else {
        this.showMessage("It looks like the access to your microphone is blocked.");
      }
    });
  }

  disconnectAudioListener() {
    this.meter.disconnect();
  }

  startDetecting() {
    // if (this.sourceAvailable) {
      this.isRecording = true;
      this.meter.listenTo(0, (dB, percent) => {
        this.iteration++;
        this.decibels = Number(`${dB}`) + 100;
        if (this.iteration === 4) {
          this.iteration = 0;
          this.updateSoundWave(this.decibels);
        }
      });
      if (this.document.getElementById('audio-input')) {
        (this.document.getElementById('audio-input') as HTMLElement).style.opacity = "1";
      }
    // }
  }
  stopDetecting() {
    // if (this.sourceAvailable) {
      this.isRecording = false;
      this.meter.stopListening();
      if (this.document.getElementById('audio-input')) {
        (this.document.getElementById('audio-input') as HTMLElement).style.opacity = "0";
      }
    // }
  }


  updateSoundWave(level: number) {
    for (let i = this.soundLevelArray.length - 1; i > 0; i--) {
      this.soundLevelArray[i] = Math.round(this.soundLevelArray[i - 1] * 0.8);
    }
    this.soundLevelArray[0] = Math.round(level) * 0.6;
    const element = this.document.getElementById('bar1');
    if (element !== null && element !== undefined) {
      for (let n = 0; n < this.soundLevelArray.length; n++) {
        (this.document.getElementById('bar' + (n + 1)) as HTMLElement).style.width = (this.soundLevelArray[n] + 3) + 'px';
      }
    }
  }


  // [Microsoft Edge, Apple Safari, Google Chrome or Chromium, Samsung Internet]  support speechrecognition


  identifyBrowser() {
    let sBrowser: any, sUsrAg = navigator.userAgent;

    if (sUsrAg.indexOf('Firefox') > -1) {
      sBrowser = 'Mozilla Firefox';
      // 'Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0'
    } else if (sUsrAg.indexOf('SamsungBrowser') > -1) {
      sBrowser = 'Samsung Internet';
      // 'Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
    } else if (sUsrAg.indexOf('Opera') > -1 || sUsrAg.indexOf('OPR') > -1) {
      sBrowser = 'Opera';
      // 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106'
    } else if (sUsrAg.indexOf('Trident') > -1) {
      sBrowser = 'Microsoft Internet Explorer';
      // 'Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko'
    } else if (sUsrAg.indexOf('Edge') > -1) {
      sBrowser = 'Microsoft Edge';
      // 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299'
    } else if (sUsrAg.indexOf('Chrome') > -1) {
      sBrowser = 'Google Chrome or Chromium';
      // 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36'
    } else if (sUsrAg.indexOf('Safari') > -1) {
      sBrowser = 'Apple Safari';
      // 'Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306'
    } else {
      sBrowser = 'unknown';
    }

    return sBrowser;
  }



  showMessage(msg: string) {
    (this.document.getElementById('message-box') as HTMLElement).classList.add('visible');
    (this.document.getElementById('message-box') as HTMLElement).innerHTML = msg;

    this.hideMessage();
  }

  hideMessage() {
    clearTimeout(this.showMsgTimout);

    this.showMsgTimout = setTimeout(() => {
      (this.document.getElementById('message-box') as HTMLElement).classList.remove('visible');
    }, 3000);
  }


}
